import React, {Component} from 'react';
import './index.css'

class BsyWebhookDoc extends Component {
    state = {
        JSONData:"",
        menu: [],
        demoinfo: {},
        currentActive: "fields"
    }
    componentDidMount() {
        React.axios("/webhook/paramsdemo",{
            appId:this.props.data.appid,
            formId:this.props.data.formid,
            type:this.props.type,
        }).then((res)=>{
            let demoinfo = res.data.data.demoinfo;
            let menu = res.data.data.menu;
            this.setState({
                menu,demoinfo
            })
        })
    }

    switchMenu = (key) => {
        const {demoinfo} = this.state;
        let JSONData = JSON.stringify(demoinfo[key],null, 4);
        this.setState({
            currentActive: key,
            JSONData: JSONData,
        })
    }

    render() {
        const {JSONData, currentActive, menu, demoinfo} = this.state
        return (
            <div className="BsyWebhookDoc">
                <div className="logging-menu">
                    {
                        menu.length > 0 && menu.map(res =>{
                            return <div className={`menu-item ${res.key === currentActive ? "select" : ""}`} onClick={()=>{return this.switchMenu(res.key)}}>
                                {res.label}
                            </div>
                        })
                    }
                </div>
                <div className="logging">
                    {currentActive === "fields" && <div className="structureTable">
                        <div className="logTable">
                            <div className="logTableHeader">
                                <div className="header-item">{React.language('widgetName')}</div>
                                <div className="header-item">{React.language('field.id')}</div>
                                <div className="header-item">{React.language('field.type')}</div>
                                <div className="header-item">{React.language('explain')}</div>
                            </div>
                            <div className="logTableBody">
                                {
                                    demoinfo.fields && demoinfo.fields.map((val)=>{
                                        return <div className="body-line">
                                            <div className="body-item">{val.label}</div>
                                            <div className="body-item">{val.id}</div>
                                            <div className="body-item">{val.type}</div>
                                            <div className="body-item">{val.description}</div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>}
                    {currentActive !== "fields" && <div className="structureCont">
                        <pre>
                            <code>
                                 {
                                     JSONData
                                 }
                            </code>
                        </pre>
                    </div>}
                </div>
            </div>
        );
    }
}

export default BsyWebhookDoc;